import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {chakra} from '@chakra-ui/react'

const ICON_STYLESHEET_SELECTOR = 'link[href*="/icon-platform/css/fico.css"]'

const FicoIcon = chakra('i')

const DynamicIcon = ({iconId = 'DL00002UN8', ...props}) => {
    useEffect(() => {
        if (typeof document === 'undefined') {
            return
        }

        const iconStylesheetLink = document.querySelector(ICON_STYLESHEET_SELECTOR)

        if (!iconStylesheetLink) {
            // The icon font only renders when the external stylesheet is present.
            console.warn(
                `DynamicIcon: missing icon stylesheet (${ICON_STYLESHEET_SELECTOR}); ${iconId} will not render.`,
            )
        }
    }, [iconId])

    return <FicoIcon className={`fico fico-${iconId}`} {...props} />
}

DynamicIcon.propTypes = {
    iconId: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
}

export default DynamicIcon
